// opervex-frontend/src/Opervex/System/OperationGoodsMovement.js

class OperationGoodsMovement {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async create(data) {
    return this.#_api.post("/System/OperationGoodsMovement/", data);
  }

  async update(id, data) {
    return this.#_api.put("/System/OperationGoodsMovement/" + id, data);
  }

  async findId(id) {
    return await this.#_api.get("/System/OperationGoodsMovement/" + id);
  }

  async findAll() {
    return await this.#_api.get("/System/OperationGoodsMovement");
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "text",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inativo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default OperationGoodsMovement;
